// import moment from "moment";
// import React from "react";
// import formatDateDDMMYYYY from "../../../../Main/formatDate";

// const ThermalInvoice = React.forwardRef((props, ref) => {
//   const { values } = props;

//   return (
//     <div ref={ref} style={styles.invoice}>
//       <div style={styles.header}>
//         <h2 className="text-base">{values?.branch?.name}</h2>
//         <p>{values?.branch?.area}</p>
//         <p>
//           {values?.branch?.city ? values?.branch?.city + ", " : ""}
//           {values?.branch?.state}
//         </p>
//         <p>{values?.branch?.country}</p>
//         <p>PHONE : {values?.branch?.phone}</p>
//         <p>EMAIL : {values?.branch?.email}</p>
//         <p>VATIN : {values?.branch?.tax}</p>
//       </div>
//       <div style={styles.details}>
//         <p>Invoice : {`#INV-${values?.number}`}</p>
//         <p>
//           Customer :
//           {values?.customer?.name ? values?.customer?.name : "Walk-in-customer"}
//         </p>
//         <p>Phone :{values?.customer?.phone ? values?.customer?.phone : ""}</p>
//         <p>Date:{formatDateDDMMYYYY(values?.date)}</p>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div style={styles.items}>
//         <table style={styles.table}>
//           <thead>
//             <tr className="border-b border-dashed border-black">
//               <th className="p-1" style={styles.th}>
//                 Item
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Unit
//               </th>
//               <th className="p-1" style={styles.th}>
//                 QTY
//               </th>
//               <th className="p-1" style={styles.th}>
//                 PRC
//               </th>
//               <th className="px-1" style={styles.th}>
//                 TAX
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Total
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {values?.details?.map((item, index) => (
//               <React.Fragment>
//                 <tr key={index}>
//                   <td className="p-1" style={styles.td} colSpan={5}>
//                     <div>{item?.name}&nbsp;</div>
//                     <div>#BATCH-{item?.description?.number}</div>
//                     <div>
//                       {item?.description?.expiry_date
//                         ? "Expiry : " +
//                           formatDateDDMMYYYY(item?.description?.expiry_date)
//                         : ""}
//                     </div>
//                   </td>
//                 </tr>
//                 <tr key={index}>
//                   <td colSpan={1}></td>
//                   <td className="p-1" style={styles.td}>
//                     {item?.unit_name}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.quantity?.toFixed(3)}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.sale_price?.toFixed?.(3)}</div>
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.tax}%</div>
//                     {/* <div>{item?.tax_amount?.toFixed?.(3)}</div> */}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.total?.toFixed?.(3)}
//                   </td>
//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div
//         style={styles?.total}
//         className="pr-2 border-t border-dashed border-black pt-2"
//       >
//         <p>Subtotal: {values?.subtotal?.toFixed(3)}</p>
//         <p>Taxamount: {values?.taxamount?.toFixed(3)}</p>
//         <p>
//           Discount:
//           {values?.discount ? "-" + values?.discount?.toFixed(3) : "0.000"}
//         </p>
//         <p>
//           Delivery:
//           {values?.delivery ? "+" + values?.delivery?.toFixed(3) : "0.000"}
//         </p>
//         <h3 className="text-medium">
//           Total: OMR&nbsp;{values?.total?.toFixed(3)}
//         </h3>
//       </div>
//       <div className="mt-2 border-t border-dashed border-black" />
//       <div className="mt-2 border-t border-dashed border-black" />
//     </div>
//   );
// });

// const styles = {
//   invoice: {
//     width: "80mm",
//     fontSize: "12px",
//     padding: "10px",
//   },
//   header: {
//     textAlign: "center",
//     marginBottom: "10px",
//   },
//   details: {
//     marginBottom: "10px",
//   },
//   items: {
//     marginBottom: "10px",
//   },
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//   },
//   th: {
//     textAlign: "left",
//   },
//   td: {
//     padding: "5px 0",
//   },
//   total: {
//     textAlign: "right",
//   },
// };

// export default ThermalInvoice;


/**
 * new version 2.0 - better Arabic support, cleaner layout, more robust formatting
 * Date - 1-3-2026
 */ 

import React from "react";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";

const ThermalInvoice = React.forwardRef((props, ref) => {
  const { values } = props;

  const formatLabel = (english, arabic) => (
    <span>
      {english}
      <br />
      <span
        style={{
          fontSize: "10.5px",           // ← slightly larger than 10px
          fontWeight: 500,              // ← helps visibility
          lineHeight: 1.25,
        }}
      >
        {arabic}
      </span>
    </span>
  );

  return (
    <div
      ref={ref}
      dir="rtl"
      style={{
        ...styles.invoice,
        direction: "rtl",
        textAlign: "right",
        fontFamily:
          // Order matters — better chance printer/browser finds a good Arabic font
          "'Amiri', 'Noto Naskh Arabic', 'Traditional Arabic', 'Arial', 'Tahoma', sans-serif",
        WebkitPrintColorAdjust: "exact",       // Helps some browsers
        printColorAdjust: "exact",
      }}
    >

      <div style={{ ...styles.header, textAlign: "center" }}>
        <h2 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: 700 }}>
          {values?.branch?.name}
        </h2>
        <p style={{ margin: "2px 0", fontSize: "11.5px" }}>{values?.branch?.area}</p>
        <p style={{ margin: "2px 0", fontSize: "11.5px" }}>
          {values?.branch?.city ? values?.branch?.city + "، " : ""}
          {values?.branch?.state}
        </p>
        <p style={{ margin: "2px 0", fontSize: "11.5px" }}>{values?.branch?.country}</p>

        <p style={{ margin: "10px 0 4px 0" }}>
          {formatLabel("Phone", "الهاتف")}: {values?.branch?.phone || "—"}
        </p>
        <p style={{ margin: "4px 0" }}>
          {formatLabel("Email", "البريد الإلكتروني")}:{" "}
          {values?.branch?.email || "—"}
        </p>
        <p style={{ margin: "6px 0 4px 0" }}>
          {formatLabel("VATIN", "الرقم الضريبي")}: {values?.branch?.tax || "—"}
        </p>
      </div>

      <div style={styles.details}>
        <p>{formatLabel("Invoice No", "رقم الفاتورة")}: #INV-{values?.number}</p>
        <p>
          {formatLabel("Customer", "العميل")}:{" "}
          {values?.customer?.name || "Walk-in Customer / زبون عابر"}
        </p>
        <p>{formatLabel("Phone", "الهاتف")}: {values?.customer?.phone || "—"}</p>
        <p>
          {formatLabel("Date", "التاريخ")}: {formatDateDDMMYYYY(values?.date)}
        </p>
      </div>

      <div className="my-3 border-t border-dashed border-black" />

      <div style={styles.items}>
        <table style={{ ...styles.table, direction: "rtl" }}>
          <thead>
            <tr className="border-b border-dashed border-black">
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("Item", "الصنف")}
              </th>
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("Unit", "الوحدة")}
              </th>
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("QTY", "الكمية")}
              </th>
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("Price", "السعر")}
              </th>
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("Tax", "الضريبة")}
              </th>
              <th style={{ ...styles.th, textAlign: "right" }}>
                {formatLabel("Total", "الإجمالي")}
              </th>
            </tr>
          </thead>
          <tbody>
            {values?.details?.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td colSpan={6} style={{ ...styles.td, padding: "8px 3px 3px" }}>
                    <div style={{ fontWeight: 700, fontSize: "12px" }}>{item?.name}</div>
                    {item?.description?.number && (
                      <div style={{ fontSize: "10.5px" }}>#BATCH-{item.description.number}</div>
                    )}
                    {item?.description?.expiry_date && (
                      <div style={{ fontSize: "10.5px" }}>
                        {formatLabel("Expiry", "تاريخ الانتهاء")}:{" "}
                        {formatDateDDMMYYYY(item.description.expiry_date)}
                      </div>
                    )}
                    {item?.frame_type && <div style={{ fontSize: "10.5px" }}>{formatLabel("Frame", "الإطار")}: {item?.frame_type}</div>}
                    {item?.lens_type && <div style={{ fontSize: "10.5px" }}>{formatLabel("Lens", "العدسة")}: {item?.lens_type}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ ...styles.td, width: "6%" }}></td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {item?.unit_name || "—"}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {Number(item?.quantity || 0).toFixed(3)}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {Number(item?.sale_price || 0).toFixed(3)}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right" }}>
                    {Number(item?.tax || 0)}%
                  </td>
                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontWeight: 700,
                      fontSize: "12px",
                    }}
                  >
                    {Number(item?.total || 0).toFixed(3)}
                  </td>
                </tr>

                {index < (values?.details?.length || 0) - 1 && (
                  <tr>
                    <td colSpan={6} style={{ height: "10px" }}></td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="my-3 border-t border-dashed border-black" />

      <div style={{ ...styles.total, textAlign: "right" }}>
        <div className="flex justify-between">
          <span>{formatLabel("Subtotal", "المجموع الفرعي")}</span>
          <span>{Number(values?.subtotal || 0).toFixed(3)}</span>
        </div>
        <div className="flex justify-between">
          <span>{formatLabel("Tax Amount", "مبلغ الضريبة")}</span>
          <span>{Number(values?.taxamount || 0).toFixed(3)}</span>
        </div>
        <div className="flex justify-between">
          <span>{formatLabel("Discount", "الخصم")}</span>
          <span>
            {values?.discount > 0 ? "-" : ""}
            {Number(values?.discount || 0).toFixed(3)}
          </span>
        </div>
        <div className="flex justify-between">
          <span>{formatLabel("Delivery", "التوصيل")}</span>
          <span>
            {values?.delivery > 0 ? "+" : ""}
            {Number(values?.delivery || 0).toFixed(3)}
          </span>
        </div>

        <hr className="my-2 border-black" />

        <div className="flex justify-between text-[13px] font-bold">
          <span>{formatLabel("Grand Total", "الإجمالي")}</span>
          <span><UserCurrency/> / ر.ع {Number(values?.total || 0).toFixed(3)}</span>
        </div>
      </div>

      {/* Prescription Section */}
      {values?.prescription && (
        <div style={{ marginTop: "16px", marginBottom: "12px" }}>
          <div style={{ textAlign: "center", fontWeight: 700, fontSize: "12px", marginBottom: "8px" }}>
            {formatLabel("Prescription (Eyes Wear)", "وصفة النظارات الطبية")}
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "10px" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{formatLabel("EYE", "العين")}</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>SPH</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>CYL</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>AXIS</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>ADD</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>PRISM</th>
                <th style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>PD</th>
              </tr>
            </thead>
            <tbody>
              {["R", "L"].map((eye) => (
                <tr key={eye}>
                  <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: 600 }}>
                    {eye === "R" ? (formatLabel("R", "يمين")) : (formatLabel("L", "يسار"))}
                  </td>
                  {["sph", "cyl", "axis", "add", "prism", "pd"].map((field) => (
                    <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }} key={field}>
                      {values?.prescription?.[eye]?.[field] || "-"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {values?.note && (
        <div style={{ marginBottom: "12px" }}>
          <div style={{ fontWeight: 700, fontSize: "11px", marginBottom: "4px" }}>
            {formatLabel("Note", "ملاحظة")}
          </div>
          <div style={{ fontSize: "10.5px" }} dangerouslySetInnerHTML={{ __html: values?.note }} />
        </div>
      )}

      <div className="mt-5 text-center text-[11px] leading-5">
        Thank you for shopping with us
        <br />
        شكراً لتسوقكم معنا
        <br />
        Wishing you continued health & wellness – نتمنى لكم دوام الصحة والعافية
      </div>
    </div>
  );
});

const styles = {
  invoice: {
    width: "80mm",
    maxWidth: "80mm",
    fontSize: "12px",               // ← base size increased
    lineHeight: 1.45,               // ← better for Arabic
    padding: "10px 7px",            // ← little more breathing room
    color: "#000",
    backgroundColor: "#fff",
  },
  header: {
    marginBottom: "12px",
  },
  details: {
    marginBottom: "12px",
    lineHeight: 1.5,
  },
  items: {
    marginBottom: "12px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "6px 4px",
    fontWeight: 700,
    fontSize: "11.5px",
  },
  td: {
    padding: "4px 4px",
    verticalAlign: "top",
  },
  total: {
    fontSize: "12.5px",
  },
};

export default ThermalInvoice;